// AimTrainer.jsx
import React, { useState, useEffect, useRef } from 'react';
import './AimTrainer.css';

export default function AimTrainer() {
  const [target, setTarget] = useState(null);
  const [score, setScore] = useState(0);
  const [shots, setShots] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(20);
  const [showResult, setShowResult] = useState(false);
  const gameAreaRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (isRunning && timeLeft > 0) {
      timerRef.current = setTimeout(() => setTimeLeft(prev => prev - 1), 1000);
    } else if (timeLeft === 0) {
      endGame();
    }
    return () => clearTimeout(timerRef.current);
  }, [isRunning, timeLeft]);

  const spawnTarget = () => {
    const gameArea = gameAreaRef.current;
    if (!gameArea) return;
    const size = 50;
    const x = Math.random() * (gameArea.clientWidth - size);
    const y = Math.random() * (gameArea.clientHeight - size);
    const id = Math.random().toString(36).substr(2, 9);
    setTarget({ id, x, y });
  };

  const startGame = () => {
    setIsRunning(true);
    setScore(0);
    setShots(0);
    setTarget(null);
    setShowResult(false);
    setTimeLeft(20);
    spawnTarget();
  };

  const endGame = () => {
    setIsRunning(false);
    setTarget(null);
    setShowResult(true);
  };

  const handleClick = (e) => {
    if (!isRunning) return;
    setShots(prev => prev + 1);

    const rect = gameAreaRef.current.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;

    if (
      target &&
      clickX >= target.x && clickX <= target.x + 50 &&
      clickY >= target.y && clickY <= target.y + 50
    ) {
      setScore(prev => prev + 1);
      spawnTarget();
    }
  };

  const accuracy = shots === 0 ? 0 : Math.round((score / shots) * 100);

  return (
    <div className="aim-trainer-section">
      <div className="stats">
        <span>Hits: {score}</span>
        <span>Shots: {shots}</span>
        <span>Accuracy: {accuracy}%</span>
        <span>Time Left: {timeLeft}s</span>
      </div>
      <div className="controls">
        {!isRunning ? (
          <button className="btn primary" onClick={startGame}>Start</button>
        ) : (
          <button className="btn secondary" onClick={endGame}>End</button>
        )}
      </div>
      <div className="game-area" ref={gameAreaRef} onClick={handleClick}>
        {isRunning && target && (
          <div className="target" style={{ top: target.y, left: target.x }}></div>
        )}
        {showResult && (
          <div className="result-overlay">
            <p><strong>Total Hits:</strong> {score}</p>
            <p><strong>Total Shots:</strong> {shots}</p>
            <p><strong>Accuracy:</strong> {accuracy}%</p>
          </div>
        )}
        <p className="created-by">Created by Arian Kazemi</p>
      </div>
    </div>
  );
}